import * as APP_CONFIG from "../constants/config";
import moment from 'moment';
import {fetchData,setPerformance} from "../util/util";

const {benchmarkApi,DBDateFormat, DBDatePattern} = APP_CONFIG;

export function itemsHasErrored(bool) {

    console.log(`action.items hasErrored: ${bool}`);

    return {
        type: 'ITEMS_HAS_ERRORED',
        hasErrored: bool,
        isLoading: false,
    };
}
export function itemsIsLoading(bool) {
    return {
        type: 'ITEMS_IS_LOADING',
        isLoading: bool
    };
}
export function itemsFetchDataSuccess(items) {
    return {
        type: 'ITEMS_FETCH_DATA_SUCCESS',
        isLoading: false,
        hasErrored: false,
        items: setPerformance(items)
    };
}

export function itemsFetchData() {

    return async (dispatch, getState) => {

        dispatch(itemsIsLoading(true));

        try{
            const period = getState().filters.showPeriod;
            let url = benchmarkApi + 'benchmark/data';
            let items = [];
            //let todayInverters, yesterdayInverters;
            const yesterdayDate = moment().add(-1, 'days').format(DBDateFormat);
            const todayDate = moment().format(DBDateFormat);

            const {monthItems} = getState();

            //console.log(`huidige period: ${period}`);

            if(period === 'today'){
                //console.log(`period today`);
                url += `/${todayDate}`;
                items = await fetchData(url);
                //todayInverters = items.inverters;
            }
            else if(period === 'yesterday'){
                if(monthItems.hasOwnProperty(yesterdayDate)){
                    items = monthItems[yesterdayDate];
                }
                else {
                    console.error(`monthitems heeft geen ${yesterdayDate}`);
                    url += `/${yesterdayDate}`;
                    items = await fetchData(url);
                }
            }
            else if(period === 'week'){
                console.log('monthItems',monthItems)
                items = monthItems['week'];
            }
            else if(DBDatePattern.test(period)){ // een bepaalde dag
                if(monthItems.hasOwnProperty(period)){
                    items = monthItems[period];
                }
                else {
                    console.log(`monthitems heeft geen ${period}`);
                    url += `/${period}`;
                    items = await fetchData(url);
                }
            }
            else{
                throw Error(`invalid period: ${period}`);
            }

            dispatch(itemsFetchDataSuccess(items));
        }
        catch(err){
            console.log(`error:`,err);
            dispatch(itemsHasErrored(true));
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/items.js